import React, { Component } from "react";

import AddBookCategory from "../AddBookCategory/AddBookCategory";

class EditBookCategory extends Component {
  render() {
    return (
      <AddBookCategory
        editStatus={true}
        categoryId={this.props.match.params.categoryId}
      />
    );
  }
}

export default EditBookCategory;
